let env;
let baseURL;
let previewURL;
let consumerURL;
let firebaseConfig;
let b4e_consumer_portal_link;
const productionHostname = '';
const stagingHostname = 'b4e-v2-staging.herokuapp.com';
const staging2Hostname = 'client-v2-dev.herokuapp.com';
const staging3Hostname = 'saas.benefits4expats.com';


if (window.location.hostname === productionHostname) {
  env = 'production';
  baseURL = '';
  previewURL = '';
  consumerURL = '';
} else if (window.location.hostname === stagingHostname) {
  env = 'staging';
  baseURL = 'https://b4ev2-staging.herokuapp.com/api';
  previewURL = 'https://b4e-v2-staging.herokuapp.com';
  consumerURL = 'https://b4e-v2-staging.herokuapp.com/web';
} else if (window.location.hostname === staging2Hostname) {
  env = 'staging';
  baseURL = 'https://client-v2-api.herokuapp.com/api';
  previewURL = 'https://client-v2-dev.herokuapp.com';
  consumerURL = 'https://client-v2-dev.herokuapp.com/web';
} else if (window.location.hostname === staging3Hostname) {
  env = 'staging';
  baseURL = 'https://saas.benefits4expats.com/api';
  previewURL = 'https://saas.benefits4expats.com';
  consumerURL = 'https://saas.benefits4expats.com/web';
} else {
  env = 'local';
  baseURL = 'http://localhost:3011/api';
  previewURL = 'http://localhost:3011';
  consumerURL = 'http://localhost:3025/web';
}

if (env === "local" || env === "staging") {
  firebaseConfig = {
    apiKey: "AIzaSyCKQ1omdDOQJHyS_6sYnZmczBmZXNYrwR4",
    authDomain: "b4e-api-staging.firebaseapp.com",
    projectId: "b4e-api-staging",
    storageBucket: "b4e-api-staging.appspot.com",
    messagingSenderId: "1062060015311",
    appId: "1:1062060015311:web:5911d6aac17fae2c2b81ba"
  }
} else {
  firebaseConfig = {

  }
}
export const ENV = env;
export const API_BASE_URL = baseURL;
export const BASE_URL = previewURL;
export const FIREBASE_CONFIG = firebaseConfig;
export const CONSUMER_PORTAL_URL = consumerURL;